import React from 'react';
import {Box, ButtonProps, LinearProgress} from '@mui/material';
import {LoadingButton} from '@mui/lab';

type LLButtonProps = { isLoading?: boolean } & ButtonProps;

export const LLButton = (props: LLButtonProps) => {
	const {color = 'primary', variant = 'contained', isLoading = false, ...rest} = props;
	const sx = ({
		root: {
			'& .MuiLoadingButton-loadingIndicator': {
				width: '80%',
			},
			'&.Mui-disabled': isLoading
				? {
					backgroundColor: `${color}.light`,
				}
				: {},
		},
	});
	
	return (
		<LoadingButton
			color={color}
			variant={variant}
			loading={isLoading}
			loadingIndicator={<Box flex={1} width={'100%'}>
				<LinearProgress color={color === 'primary' ? 'secondary' : 'primary'}/>
			</Box>}
			{...rest}
			sx={[
				sx.root,
				...(Array.isArray(props.sx)
					? props.sx
					: [props.sx]),
			]}
			className={props.className}
		>
			<span>{props.children}</span>
		</LoadingButton>
	);
};
